export default __webpack_public_path__ + "static/logo-your-bp-ddd995dbefdebe4631a8466c17df85d0.png";